export class KuaaTransactionGenericDto {
    id?:     number;
    name:    string;
    mensaje: string; 
    code:    string;
    state:   string;
    entityTransfer: any[];
}
